import { render, staticRenderFns } from "./parques-layer.vue?vue&type=template&id=88634766"
import script from "./parques-layer.vue?vue&type=script&lang=js"
export * from "./parques-layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports